import { atom } from "jotai";

export interface StatsDateRange {
  start_date: string; // "YYYY-MM-DD"
  end_date: string; // "YYYY-MM-DD"
}

function fmt(d: Date) {
  return d.toISOString().slice(0, 10);
}

const today = new Date();
const defaultStart = new Date(today.getFullYear(), today.getMonth(), 1);
const defaultEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

export const statsDateRangeAtom = atom<StatsDateRange>({
  start_date: fmt(defaultStart),
  end_date: fmt(defaultEnd),
});
